// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] + "." + {"506":"a4ab4fde","536":"52441be5","889":"464b6e21"}[chunkId] + ".js";
};